import React from "react";

const UnauthorizedPage = () => (
    <div className="UnauthorizedPage">
        <h1>Du behöver logga in för att komma åt denna sida!</h1>
    </div>
);

export default UnauthorizedPage;
